<script setup lang="ts">
defineProps({
    blok: Object,
})

const localePath = useLocalePath()
</script>

<template>
    <section class="relative">
        <div class="absolute top-0 left-0 w-full h-[300px] bg-gradient-to-b from-chsc-raw to-transparent z-[-1]" />
        <UiContainer>
            <div class="grid grid-cols-12 gap-12 items-center max-[769px]:pt-20 max-[769px]:gap-x-0">
                <div class="col-span-6 max-[769px]:col-span-12">
                    <header class="[&>h2]:leading-[40px] [&>h2]:mb-6 [&>h2]:font-londrina-solid [&>h2]:text-chsc-indigo-500 [&>h2]:fs-6xl [&>h2>strong]:fs-8xl [&>h2>strong]:leading-[50px] [&>p]:font-eb-garamond [&>p]:fs-xl">
                        <StoryblokRichText :doc="blok?.header" />
                    </header>
                    <footer class="mt-8">
                        <UButton
                            :to="localePath('/meet-the-team')"
                            :label="blok?.cta"
                            size="xl"
                        />
                    </footer>
                </div>
                <div class="col-span-6 max-[769px]:col-span-12">
                    <div class="relative">
                        <img
                            :src="blok?.image?.filename"
                            :alt="blok?.image?.alt"
                            class="max-w-none h-full max-[641px]:max-w-full"
                        >
                    </div>
                </div>
            </div>
        </UiContainer>
    </section>
</template>
